<form-viewer #formViewer
  [dataContainerService]="datasetACS"
  [record]="datasetRS.record.value.participant_counters"
  [formConfig]='formConfig'
  (valueChanges)="onValueChanges($event)"
></form-viewer>
<div>
  @if (tripBookingPackagesStepService.canAddTrenitalia) {
    <span class="info-icon" (click)="openInfoTrenitalia()">
      <mat-icon>info</mat-icon> Info passeggeri Trenitalia
    </span>
  }
</div>